import { Carousel, FetchError, SelfPacedTile } from "components/molecules";
import { Typography } from "components/atoms";
import { useScreenSize } from "hooks";
import { GMAT_TEST_TYPE, MCAT_TEST_TYPE, MOBILE_WIDTH } from "utils/constants";
import { useGetCourseworkQuery } from "services/homeApi";
import { useSegmentReFetch } from "context";
import { Spinner } from "components/atoms/Icon";
import { decodeToken } from "utils/functions/decodeToken";
import { getOfficeHoursDisplayName } from "utils/functions/getOfficeHoursDisplayName";
import "./index.scss";

interface IProps {
  theme: "light" | "dark";
}

export const SelfPacedLiveSessions = ({ theme }: IProps) => {
  const screen = useScreenSize();

  const payload = decodeToken();

  const { page, subject } = useSegmentReFetch();

  const testtype =
    payload && payload.hasOwnProperty("testtype") && payload.testtype;

  const { data, isLoading, isError } = useGetCourseworkQuery({
    page: page,
    ...(testtype === MCAT_TEST_TYPE ? { subject: subject } : {}),
  });

  const officeHoursDisplayName = getOfficeHoursDisplayName(testtype || "");

  const TitleHeading = () => (
    <Typography
      variant={screen.width < MOBILE_WIDTH ? "h4Bold" : "h3Bold"}
      label={
        screen.width < MOBILE_WIDTH
          ? `${officeHoursDisplayName} Sessions`
          : `My Upcoming ${officeHoursDisplayName} Sessions:`
      }
    />
  );

  return isLoading ? (
    <div className="self-paced-home-page-upcoming-session-wrapper">
      <Spinner theme={theme} />
    </div>
  ) : isError ? (
    <div className="self-paced-home-page-upcoming-session-wrapper">
      <TitleHeading />
      <FetchError content="Oops! failed to load resources." />
    </div>
  ) : data &&
    data.Segments &&
    Array.isArray(data.Segments) &&
    data.Segments.length > 1 ? (
    <div className="self-paced-home-page-upcoming-session-wrapper">
      <TitleHeading />
      <Carousel
        isShowSIdeNavigation={true}
        theme={theme}
        forceOneItemPerSlide={true}
      >
        {data &&
          data.Segments &&
          Array.isArray(data.Segments) &&
          data.Segments.map((segment: any, index: number) => (
            <SelfPacedTile
              key={index}
              borderColor={
                segment.IsTestSegment
                  ? "green"
                  : segment.IsTopicFocusSegment
                    ? "pink"
                    : "black"
              }
              isTabShow={false}
              title={segment.Description}
              startTime={segment.StarttimeUTC}
              endTime={segment.EndtimeUTC}
              profileImage={segment.InstructorPhotoUrl}
              name={segment.InstructorName}
              email={segment.InstructorEmail}
              messageIcon={true}
              theme={theme}
              btnType="score"
              segmentId={segment.ProductOfferingSegmentId}
              segmentObj={segment}
              isInstructorImageOnTop={true}
              index={index}
            />
          ))}
      </Carousel>
    </div>
  ) : data &&
    data.Segments &&
    Array.isArray(data.Segments) &&
    data.Segments.length === 1 ? (
    <div className="self-paced-home-page-upcoming-session-wrapper">
      <TitleHeading />
      <SelfPacedTile
        borderColor={
          data.Segments[0].IsTestSegment
            ? "green"
            : data.Segments[0].IsTopicFocusSegment
              ? "pink"
              : "black"
        }
        isTabShow={false}
        title={data.Segments[0].Description}
        startTime={data.Segments[0].StarttimeUTC}
        endTime={data.Segments[0].EndtimeUTC}
        profileImage={data.Segments[0].InstructorPhotoUrl}
        name={data.Segments[0].InstructorName}
        email={data.Segments[0].InstructorEmail}
        messageIcon={true}
        theme={theme}
        btnType="score"
        segmentId={data.Segments[0].ProductOfferingSegmentId}
        segmentObj={data.Segments[0]}
        isInstructorImageOnTop={true}
        index={1}
      />
    </div>
  ) : null;
};
